import { useLazyQuery } from '@apollo/client'
import FIND_ADDRESS from '@/graphqls/findAddress.gql'
import { useState } from 'react'

const useSelectStreetViewPosition = () => {
  const [streetViewPosition, setStreetViewPosition] = useState<{
    lat: number
    lng: number
  } | null>(null)
  // 查询目标房源的经纬度
  const [queryStreetViewPosition] = useLazyQuery(FIND_ADDRESS, {
    onCompleted(data) {
      const { findAddress } = data || {}
      const { streetLatitude, streetLongitude } = findAddress || {}
      if (streetLatitude && streetLongitude) {
        setStreetViewPosition({ lat: Number(streetLatitude), lng: Number(streetLongitude) })
      }
    },
    onError() {
      // onerror不做更新，仅做异常兜底
    }
  })

  const queryStreetViewPositionById = (id: string | number) => {
    queryStreetViewPosition({
      variables: { propertyId: id }
    })
  }
  return { streetViewPosition, queryStreetViewPositionById, setStreetViewPosition }
}

export default useSelectStreetViewPosition
